import type {CheckedFeatureToggle} from "@/models/administration/organization/organization";

/**
 * Moet in dezelfde volgorde staan als `Domain.Enums.FeatureToggle`: de posities zijn de waarden in de
 * database. ROUTE_CALCULATION en TRAJECTORY_OPTIMIZATION zeggen of de organisatie de knop krijgt, niet welke
 * engine hem uitvoert — dat is een organisatie-instelling.
 */
export enum FeatureToggle
{
    STATUS_HISTORY,
    ROUTE_CALCULATION,
    TRAJECTORY_OPTIMIZATION,
    TARIFFS,
    APE_PLAN_RUN
}

export const FeatureToggleOptions = (toggles: FeatureToggle[]): CheckedFeatureToggle[] => [
    {
        label: "core.feature_toggles.status_history",
        value: FeatureToggle.STATUS_HISTORY,
        checked: toggles.some(x=> x === FeatureToggle.STATUS_HISTORY),
    },
    {
        label: "core.feature_toggles.trajectory_optimization",
        value: FeatureToggle.TRAJECTORY_OPTIMIZATION,
        checked: toggles.some(x=> x === FeatureToggle.TRAJECTORY_OPTIMIZATION),
    },
    {
        label: "core.feature_toggles.route_calculation",
        value: FeatureToggle.ROUTE_CALCULATION,
        checked: toggles.some(x=> x === FeatureToggle.ROUTE_CALCULATION),
    },
    {
        label: "core.feature_toggles.tariffs",
        value: FeatureToggle.TARIFFS,
        checked: toggles.some(x=> x === FeatureToggle.TARIFFS),
    },
    {
        label: "core.feature_toggles.ape_plan_run",
        value: FeatureToggle.APE_PLAN_RUN,
        checked: toggles.some(x=> x === FeatureToggle.APE_PLAN_RUN),
    },
];
